import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function getCategories() {
  return $apiClient.get(`${ApiConfig.CATEGORIES}`);
}
